import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule, GroupTypeaheadModule, PeekModule } from '../../core-ui';
import { AddToGroupPillboxModule } from '../AddToGroupPillbox/AddToGroupPillbox.module';
import { UpdateGroupModule } from '../UpdateGroup/UpdateGroup.module';
import { GatedPillboxComponent } from './GatedPillbox.component';
import { GatedPillboxwithTypeaheadComponent } from './GatedPillboxWithTypeahead.component';
import { GroupCardComponent } from './GroupCard.component';
import { GroupShareComponent } from './GroupShare.component';
import { SharedGroupsPermissionModalComponent } from './SharedGroupsPermissionModal.component';
import { ShareGroupWithUserPillboxComponent } from './ShareGroupWithUserPillbox.component';
import { TeamShareComponent } from './TeamShare.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CoreUiModule,
        PeekModule,
        AddToGroupPillboxModule,
        GroupTypeaheadModule,
        UpdateGroupModule
    ],
    declarations: [
        GatedPillboxComponent,
        GatedPillboxwithTypeaheadComponent,
        GroupShareComponent,
        SharedGroupsPermissionModalComponent,
        ShareGroupWithUserPillboxComponent,
        TeamShareComponent,
        GroupCardComponent
    ],

    exports: [
        TeamShareComponent,
        GroupShareComponent,
        GroupCardComponent,
        ShareGroupWithUserPillboxComponent
    ],
    providers: []
})
export class GroupCardModule {}
